import latestNews from "./latestNews";

const latestNewsService = [
    {
        matcher: 'latestNews',
        reply: config => {
            return [200, latestNews];
        }
    }
]

export default latestNewsService;